import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

const IntentNode = memo(({ data, selected }) => {
  const routing = data.routing || [];
  return (
    <div
      style={{
        background: "#fff",
        border: `2px solid ${selected ? "#1a1a1a" : "#7c4dff"}`,
        borderRadius: 8,
        padding: 0,
        minWidth: 140,
        boxShadow: selected ? "0 0 0 2px rgba(0,0,0,0.15)" : "0 1px 3px rgba(0,0,0,0.08)",
        cursor: "pointer",
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: "#7c4dff", width: 8, height: 8 }} />

      {/* Header */}
      <div style={{
        background: "#ede7f6", padding: "6px 10px",
        borderBottom: "1px solid #d1c4e9", borderRadius: "6px 6px 0 0",
        display: "flex", alignItems: "center", gap: 4,
      }}>
        <span style={{ fontSize: 11 }}>&#10170;</span>
        <span style={{ fontWeight: 600, fontSize: 11, color: "#4a148c" }}>
          {data.label || "Intent Router"}
        </span>
      </div>

      {/* Routing summary */}
      <div style={{ padding: "4px 10px 6px" }}>
        {routing.slice(0, 4).map((route, i) => (
          <div key={i} style={{ fontSize: 9, color: "#666", fontFamily: "var(--font-mono)", padding: "1px 0" }}>
            /{route.pattern.slice(0, 20)}/ &rarr; {route.agentId}
          </div>
        ))}
        {routing.length > 4 && (
          <div style={{ fontSize: 9, color: "#999" }}>+{routing.length - 4} more</div>
        )}
        {data.fallback && (
          <div style={{ fontSize: 9, color: "#999", marginTop: 2, borderTop: "1px solid #eee", paddingTop: 2 }}>
            default &rarr; {data.fallback}
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Right} style={{ background: "#7c4dff", width: 8, height: 8 }} />
    </div>
  );
});

IntentNode.displayName = "IntentNode";
export default IntentNode;
